var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ui-component',{attrs:{"component-data":_vm.translationText}}),_c('ui-component',{attrs:{"component-data":_vm.translationRichtext}}),_c('ui-component',{attrs:{"component-data":_vm.translationComponents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }